<template>
  <section class="hero is-white">
    <div class="hero-body">
      <div class="container">
        <h1 class="title is-3">Tài Khoản ( {{totalAccount}} )</h1>
        Free: {{this.totalFree}} &nbsp;&nbsp;&nbsp; Business: {{this.totalBusiness}} <br>
        Người dùng: {{this.countParticipant}}
        <div>
          <download-csv
            class   = "btn-download"
            :data   = "dataExport">
            Download data
          </download-csv>
        </div>

        <div>&nbsp;</div>

        <div>
          <autocomplete
            :items="accountsSearch.map(({username}) => username)"
            @input="filterByKeyword"
          />
        </div>
        <div class="admin account-management">
          <div class="columns has-line is-mobile">
            <div class="column has-text-weight-bold has-text-left">Tài khoản</div>
            <div class="column has-text-weight-bold has-text-left">Tên</div>
            <div class="column has-text-weight-bold has-text-left">Email</div>
            <div class="column has-text-weight-bold has-text-left">Số điện thoại</div>
            <div class="column has-text-weight-bold has-text-left">Trạng thái</div>
            <div class="column has-text-weight-bold has-text-left">Ngày đăng ký</div>
            <div class="column has-text-weight-bold has-text-left">Giới hạn người dùng</div>
            <div class="column has-text-weight-bold has-text-left">Người dùng hiện tại</div>
            <div class="column has-text-weight-bold has-text-left">Tỉnh/Thành phố</div>
            <div class="column has-text-weight-bold has-text-left">
               <b-icon
                  icon="sort"
                  size="is-middle"
                  pack="fas"
                  type="is-info"
                  class="pointer"
                  @click.native="sortAccount()"
                ></b-icon>
                <span>
                  Loại tài khoản
                </span>
            </div>
          </div>
          <div class="columns has-line is-mobile" v-for="account in filteredAccounts" :key="account._id">
            <fragment v-if="selectedAccounts && account._id in selectedAccounts">
             
              <div class="column has-text-left is-bold"  style="color: blue">
                {{account.username}}
              </div>
              <div class="column has-text-left">{{account.firstName}}</div>
              <div class="column has-text-left">{{account.email}}</div>
              <div class="column has-text-left">{{account.phone}}</div>
              <div class="column has-text-left">
                <fragment v-if="!selectedAccounts[account._id].enableModified">{{account.isActive}}</fragment>
                <fragment v-else>
                  <div>
                    <b-radio
                      v-model="selectedAccounts[account._id].isActive"
                      :native-value="true"
                      type="is-info"
                    >Active</b-radio>
                  </div>
                  <div>
                    <b-radio
                      v-model="selectedAccounts[account._id].isActive"
                      :native-value="false"
                      type="is-info"
                    >Deactive</b-radio>
                  </div>
                </fragment>
              </div>
              <div class="column has-text-left">
                <fragment
                  v-if="!selectedAccounts[account._id].enableModified"
                >{{getFormatDate(account.startAt)}}</fragment>
                <fragment v-else>
                  <datepicker
                    :format="dateFormatter"
                    :input-class="'input'"
                    :placeholder="'Please select a date'"
                    v-model="selectedAccounts[account._id].startAt"
                  ></datepicker>
                </fragment>
              </div>
              <div class="column has-text-left">
                <fragment v-if="!selectedAccounts[account._id].enableModified">{{account.limit}}</fragment>
                <fragment v-else>
                  <b-input
                    placeholder="Please input limit"
                    type="number"
                    min="0"
                    v-model="selectedAccounts[account._id].limit"
                  ></b-input>
                </fragment>
              </div>
              <div class="column has-text-left">{{account.childs}}</div>
              <div class="column has-text-left">{{account.province}}</div>
              <div class="column has-text-left">
                <fragment
                  v-if="!selectedAccounts[account._id].enableModified"
                >{{getAccountType(account.level)}}</fragment>
                <fragment v-else>
                  <multiselect
                    track-by="result"
                    label="name"
                    placeholder="Please select level"
                    :options="levelOptions"
                    :searchable="true"
                    :allow-empty="true"
                    :show-labels="false"
                    @select="changeLevel"
                    :id="account._id"
                  >
                    <template slot-scope="{ option }">{{ option.name }}</template>
                  </multiselect>
                </fragment>
              </div>

            </fragment>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapState } from "vuex";
import moment from "moment";
import Utils from "../components/shared/Utils";
import _ from "lodash";

import Vue from 'vue'
import JsonCSV from 'vue-json-csv'
Vue.component('downloadCsv', JsonCSV)

export default {
  data() {
    /*
     * computed structure
     * selectedAccounts: { _id: { enableModified: false, isActive: false } }
     */
    return {
      selectedAccounts: null,
      levelOptions: [
        { name: "Free", result: 1 },
        { name: "Business", result: 2 }
      ],
      totalAccount: 0,
      keyword: "",

      sort: false,
    };
  },
  components: {
    Fragment: () => import("vue-fragment").then(({ Fragment }) => Fragment),
    Datepicker: () => import("vuejs-datepicker"),
    Multiselect: () => import("vue-multiselect"),
    Autocomplete: () => import("../components/shared/Autocomplete")
  },
  created() {
    this.fetchAccountList().then(() => {
      this.selectedAccounts = this.accounts.reduce((result, account) => {
        result = {
          ...result,
          [account._id]: {
            enableModified: false,
            username: account.username,
            isActive: account.isActive,
            startAt: account.startAt,
            limit: account.limit,
            level: account.level
          }
        };
        return result;
      }, {});

      this.totalAccount = _.size(this.accounts);
    });

  },
  methods: {
    ...mapActions("hostAccount", ["fetchAccountList", "updateAccount", "deleteAccount", 'getParticipantsWithUsername']),

    getAccountType: Utils.getAccountType,
    getFormatDate: Utils.getFormatDate,
    dateFormatter(date) {
      return moment(date).format("D/M/YYYY");
    },
    changeLevel(selectedOption, id) {
      this.selectedAccounts[id].level = selectedOption.result;
    },
    toggleEditAccount(id, editStatus = false) {
      this.selectedAccounts = {
        ...this.selectedAccounts,
        [id]: { ...this.selectedAccounts[id], enableModified: editStatus }
      };
    },
    updateAccountRow(id) {
      let { isActive, startAt, limit, level, username } = this.selectedAccounts[
        id
      ];
      limit = Number(limit);
      this.updateAccount({ isActive, startAt, limit, level, username }).then(
        () => {
          this.selectedAccounts[id].enableModified = false;
        }
      );
    },

    filterByKeyword(keyword) {
      this.keyword = keyword;
    },

    confirmCustomDelete(acount) {
      this.$dialog.confirm({
        title: 'Deleting account',
        message: 'Are you sure you want to <b>delete</b> your account? This action cannot be undone.',
        confirmText: 'Delete account',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.deleteAccount(acount).then(() => {
            this.fetchAccountList().then(() => {
              this.$toast.open('Tài khoản đã xoá!')
            });
          })
          
        }
      })
    },

    sortAccount() {
      this.sort = !this.sort;

      

      if(this.sort) {
        this.accounts.sort((a,b) => (a.level > b.level) ? 1 : ((b.level > a.level) ? -1 : 0));
      } else {
        this.accounts.sort((a,b) => (a.level > b.level) ? -1 : ((b.level > a.level) ? 1 : 0));

      }
    }

  },
  computed: {
    ...mapState("hostAccount", ["accounts"]),
    accountsSearch() {
      return this.accounts || [];
    },
    filteredAccounts() {
      if (this.keyword === "") return this.accounts;
      return this.accounts
        ? this.accounts.filter(({ username }) => username === this.keyword)
        : [];
    },

    totalFree() {
      // return null
      let count = 0;
      if(this.accounts) {
        this.accounts.forEach(item => {
          if(item.level === 1) {
            count++;
          }
        }) 
      }
      return count
    },
    totalBusiness() {
      let count = 0;
      if(this.accounts) {
        this.accounts.forEach(item => {
          if(item.level === 2) {
            count++;
          }
        }) 
      }
      return count
    },

    dataExport() {
      const data = [];
      if(this.accounts) {
        this.accounts.forEach(item => {
          data.push({
            "Tài Khoản": item.username,
            "Tên": item.firstName,
            "Email": item.email,
            "Số Điện Thoại": item.phone,
            "Trạng thái": item.isActive,
            "Công Ty": item.company,
            "Giới Hạn Người Dùng": item.limit,
            "Người Dùng Hiện Tại": item.childs,
            "Tỉnh/Thành phố": item.province,
            "Ngày Đăng Ký": this.$moment(item.startAt).format("Do/MM/YYYY"),
            "Loại Tài Khoản": item.level === 2 ? 'Business' : "Free",
          }) 
        }) 
      }
      return data;
    },

    countParticipant() {
      let countAccount = 0
      this.accounts.forEach( item => {
        countAccount += item.childs
      })
      return countAccount;
    }

  }
};
</script>

<style lang="scss" scope>
.has-line {
  box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
  hyphens: auto;
  word-break: break-word;
}
.pointer {
  cursor: pointer;
}
.close-icon {
  margin-left: 10px;
}
.hero-body {
  padding-top: 0;
}

.account-management {
  padding: 20px;
}
.w70 {
  max-width: 70px;
}

.btn-download {
  display: inline-block;
  color: blue;
  text-decoration: underline;
  cursor: pointer
}
</style>